module.exports = __webpack_public_path__ + "img/mn.5c65c3f3.svg";